import { Link, useNavigate } from '@solidjs/router';
import { Show, useContext } from 'solid-js';
import { AppContext } from '../../app-context-provider/app-context-provider';
import myContentStore from '../../stores/my-content-store';
import theme from '../../style/theme';
import { GlobeIcon } from '../icons-library/globe';
import { MagnifyingGlassIcon } from '../icons-library/magnifying-glass';
import { ShoppingBasketIcon } from '../icons-library/shopping-basket';
import { StarIcon } from '../icons-library/star';
import { localeMenuIsOpen, toggleCountrySelectionMenu } from '../../stores/locale-store';
import { UserControls } from '../login-controls/login-controls';
import { StyledHeaderIcon } from './header.style';
import { removeTrailingSlash } from '../../tools/remove-trailing-slash';

export const HeaderNavigationShortcuts = () => {
    const { appStore, viewport, searchPage, shopPage, pageRegistration, myContentPage, siteInfo, localize } = useContext(AppContext);
    const { close } = appStore;
    const { myContentHasItems } = myContentStore;
    const isMobile = () => viewport.width <= theme.breakpoints.MOBILE;
    const navigate = useNavigate();

    return (
        <>
            <Show when={pageRegistration.url && pageRegistration.url !== ''}>
                <UserControls />
            </Show>

            <Show when={!isMobile() && (!siteInfo?.siteType || siteInfo?.siteType === 'default')}>
                <Show when={myContentPage.url && myContentPage.url !== ''}>
                    <StyledHeaderIcon>
                        <button 
                            onClick={() => {
                                close();
                                navigate(`${removeTrailingSlash(myContentPage.url)}`);
                            }}
                            aria-label={localize('header_my_content_icon', 'Link to My content')}
                        >
                            <StarIcon
                                fill={theme.palette[myContentHasItems() ? 'red' : 'darkGray']}
                                {...(viewport.width < theme.breakpoints.MOBILE
                                    ? {
                                        height: 2.5,
                                        width: 2.5,
                                        opacity: 0.7,
                                    }
                                    : {})}
                            />
                        </button>
                    </StyledHeaderIcon>
                </Show>
            </Show>

            <Show when={!siteInfo?.siteType || siteInfo.siteType === 'default'}>
                <Show when={shopPage.url && shopPage.url !== '' && !isMobile()}>
                    <StyledHeaderIcon>
                        <Link
                            href={removeTrailingSlash(shopPage.url)}
                            style={{ display: 'flex', 'align-items': 'center' }}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <ShoppingBasketIcon
                                ariaLabel={localize('header_shop_icon', 'Link to Shop')}
                                {...(viewport.width < theme.breakpoints.MOBILE
                                    ? {
                                        height: 2.5,
                                        width: 2.5,
                                        opacity: 0.7,
                                    }
                                    : {})}
                            />
                        </Link>
                    </StyledHeaderIcon>
                </Show>
            </Show>

            <Show when={searchPage?.url && searchPage.url !== ''}>
                <StyledHeaderIcon onClick={close}>
                    <button
                        onClick={() => {
                            close();
                            navigate(`${removeTrailingSlash(searchPage.url)}`);
                        }}
                        aria-label={localize('header_search_icon', 'Link to Search page')}
                    >
                        <MagnifyingGlassIcon
                            {...(viewport.width < theme.breakpoints.MOBILE
                                ? {
                                    height: 2.5,
                                    width: 2.5,
                                    opacity: 0.7,
                                }
                                : {})}
                        />
                    </button>
                </StyledHeaderIcon>
            </Show>

            <Show when={!isMobile() && (!siteInfo?.siteType || siteInfo?.siteType === 'default')}>
                <StyledHeaderIcon
                    isActive={localeMenuIsOpen()}
                >
                    <button
                        onClick={() => {
                            close();
                            toggleCountrySelectionMenu();
                        }}
                        tabIndex="0"
                        aria-label={localize('header_country_selection_icon', 'Open country selection menu')}
                    >
                        <GlobeIcon
                            {...(viewport.width < theme.breakpoints.MOBILE
                                ? {
                                    height: 2.5,
                                    width: 2.5,
                                    opacity: 0.7,
                                }
                                : {})}
                        />
                    </button>
                </StyledHeaderIcon>
            </Show>
        </>
    );
};
